module.exports = __webpack_public_path__ + "static/img/20002 (2).1d873d7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20002 (2).webp
// module id = n7Sr
// module chunks = 14